import React from "react";

// CSS phone frame around the app's home-screen screenshot.
export default function PhoneMockup({ className = "", src = "/assets/images/app-home.webp", alt = "Prepaid Meter app home screen" }) {
  return (
    <div className={`relative mx-auto w-[240px] sm:w-[270px] lg:w-[300px] ${className}`}>
      <div className="relative rounded-[3rem] bg-[#0b0f24] p-[10px] shadow-[0_40px_80px_-20px_rgba(1,6,35,0.55)] ring-1 ring-white/10">
        <div className="absolute left-1/2 top-[18px] z-10 h-[22px] w-[84px] -translate-x-1/2 rounded-full bg-black" />
        <img
          src={src}
          alt={alt}
          className="block w-full rounded-[2.4rem] bg-white object-cover"
          style={{ aspectRatio: "924 / 2000" }}
          loading="lazy"
        />
      </div>
      <span className="absolute -left-[3px] top-28 h-10 w-[3px] rounded-l bg-[#0b0f24]" />
      <span className="absolute -right-[3px] top-36 h-16 w-[3px] rounded-r bg-[#0b0f24]" />
    </div>
  );
}
